<template>
    <PanelInformativo style="height: 4vh;" :timeslide="tiempo" class="bg-black">
        <template v-slot:buttons>
            <v-btn icon="mdi mdi-minus" @click="lessTime"
                style="width: 3.5vh; height: 3.5vh; font-size: 1.5vh; margin-right: 1vh; margin-bottom: 1vh;">
            </v-btn>
            <v-btn icon="mdi mdi-plus" @click="moreTime"
                style="width: 3.5vh; height: 3.5vh; font-size: 1.5vh; margin-right: 1.5vh; margin-bottom: 1vh;">
            </v-btn>
            <input type="number" class="bg-grey-darken-4 rounded text-center no-spin" v-model="tiempo"
                style="width: 4.5vh; height: 3.5vh; font-size: 1.5vh; margin-right: 1.5vh; margin-bottom: 1.2vh; ">
        </template>
    </PanelInformativo>
    <swiper :autoplay="{
        delay: secondsToMilliseconds(), disableOnInteraction: false,
    }" :modules="modules" :rewind="true" :breakpoints="BREAKPOINTS" class="mySwiper overflow-hidden">

        <swiper-slide v-for="(lott, key) in resultados.animals" :key="key" >
            <CardAnimales :loteria="lott" :nombre="LOTTERY_NAMES[key]" />
        </swiper-slide>


        <swiper-slide v-for="(item, index) in zodiacalInPairs" :key="index">
            <v-container class="my-auto" >
                <v-row v-for="(lott, ind) in item" :key="ind" >
                    <CardZodiacal :loteria=lott[1] :nombre="LOTTERY_NAMES[lott[0]] || lott[0]" />
                </v-row>
            </v-container>
        </swiper-slide>

        <swiper-slide v-for="(item, index) in lotteryInPairs" :key="index">
            <v-container class="my-auto">
                <v-row v-for="(lott, ind) in item" :key="ind">
                    <CardLoteria :loteria=lott[1] :nombre="LOTTERY_NAMES[lott[0]] || lott[0]" />
                </v-row>
            </v-container>
        </swiper-slide>

    </swiper>
    
</template>

<script>
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// Import Swiper Vue.js components
import {
    Swiper,
    SwiperSlide
} from 'swiper/vue';
import {
    Autoplay,
    Navigation,
    Pagination,
} from 'swiper';
import {
    getFullDate, orderInPairs
} from './helpers/utils'
import PanelInformativo from './components/PanelInformativo.vue';
import {
    defineAsyncComponent
} from '@vue/runtime-core';
import firebase from '@/configFirebase/firebase'
import {
    getDatabase,
    ref,
    onValue
} from '@firebase/database';
import {
    LOTTERY_NAMES
} from './helpers/dictionary';
import {
    BREAKPOINTS,
    FILTERS
} from './helpers/constants';

export default {
    components: {
        Swiper,
        SwiperSlide,
        CardAnimales: defineAsyncComponent(() => import("./components/CardAnimales.vue")),
        CardZodiacal: defineAsyncComponent(() => import("./components/CardZodiacal.vue")),
        CardLoteria: defineAsyncComponent(() => import("./components/CardLoteria.vue")),
        PanelInformativo,
    },
    data() {
        return {
            unidades: null,
            tiempo: 10,
            resolucion: screen.width,
            resultados: {
                animals: {},
                zodiacal: {},
                lottery: {}
            },
            LOTTERY_NAMES,
            BREAKPOINTS,
            modules: [Autoplay, Pagination, Navigation],
        }
    },
    methods: {
        moreTime() {
            this.tiempo++;
        },
        lessTime() {
            this.tiempo > 1 ? this.tiempo -= 1 : ""
        },
        secondsToMilliseconds() {
            return this.tiempo * 1000
        },
        listenToRealtimeChanges() {
            const db = getDatabase(firebase);
            const dbRef = ref(db, `resultados/${getFullDate()}`);
            onValue(dbRef, (snapshot) => {
                const lotteries = snapshot.val()
                for (const key in lotteries) {
                    const lotteryName = key.toUpperCase()
                    if (FILTERS.animals.includes(lotteryName)) this.resultados.animals[lotteryName] = lotteries[key]
                    if (FILTERS.zodiacal.includes(lotteryName)) this.resultados.zodiacal[lotteryName] = lotteries[key]
                    if (FILTERS.lottery.includes(lotteryName)) this.resultados.lottery[lotteryName] = lotteries[key]
                }
            });
        }
    },
    computed: {
        zodiacalInPairs() {
            return orderInPairs(this.resultados.zodiacal)
        },
        lotteryInPairs() {
            return orderInPairs(this.resultados.lottery)
        }
    },
    async created() {
        this.unidades = this.resolucion / 350;
        this.listenToRealtimeChanges();
    }
};
</script> 

<style>
#app {
    height: 100%;
}

html,
body {
    position: relative;
    height: 100%;
    overflow: hidden;
}

body {
    background-image: url(./assets/background.jpg);
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    background-size:cover;
    background-attachment: fixed;
    margin: 0;
    padding: 0;
}

.swiper {
    width: 100%;
    /* background: #fff; */
    height: 93vh;
}

.swiper-slide {
    font-size: 18px;
    /* background: #090815; */
    /* Center slide text vertically */
    display: flex;

}

footer {
    color: rgb(255, 255, 255);
    background-color: #000;
    height: 3vh;
}

.info {
    font-size: 1.6vh;
    text-align: center;
    line-height: 2.7vh;
}

.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spin {
    -moz-appearance: textfield;
    /* Firefox */
}

/* .swiper-slide img {
    display: block;
    width: 85%;
    height: 85%;
    margin: 0 auto;
    object-fit: scale-down;
} */
</style>
